import React, { Component } from 'react';
import '../../Style/login.css';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AVATable extends Component {
  constructor() {
    super();
    this.state = {
      expended:false,
      columns:[],
      menuList: [],
      data : []
    };

   
  }



  createHeader = (columns) =>{
    var header = columns.map((column, i)=>{
      return (
      <div key={i} className={"table-cell "+column.type} onClick={this.props.sortHeader.bind(this,column)}>
        <div>{column.name}</div>
        <span>
          {column.sort !== "" && column.sort !== null? (column.sort ==="up"? <FontAwesomeIcon icon="sort-amount-up" /> : <FontAwesomeIcon icon="sort-amount-down-alt" />):null}
        </span>
      </div>
      )
    })


    return (
      <div className="table-head">
        <div className="table-row">
          {header}
        </div>
      </div>
    );
  }

  formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
  }

  createBody = (data) =>{
    

    var columns = this.props.columns;

    var body = data.map((dataItem, i)=>{
      var cells = [];

      for(var keys in columns) {
        if(dataItem[keys]!== undefined){
          var isNumber = dataItem[keys].type ==="number" ? " number " : "";
          var isNegative = isNaN(parseInt(dataItem[keys].name, 10)) ? "" : (parseInt(dataItem[keys].name, 10) <0 ? " negative ": "");
  
          cells.push(
          <div 
            className={"table-cell"+isNumber+isNegative+" "+columns[keys].type} 
            key={keys}
            title={dataItem[keys].name}
            >
              {isNumber ? this.formatNumber(Number.parseFloat(dataItem[keys].name).toFixed(2)) : dataItem[keys].name} {isNumber? "EUR":null}
          </div>
          );
        }else{
          cells.push(
            <div 
              className={"table-cell number"} 
              key={keys}
              title="0"
              >
                0 EUR 
            </div>
            );
        }

        
      };
      
      return (
        <div className="table-row" key={i}>
          {cells}
        </div>
      )
    })

    return (
      <div className="table-body">
        {body}
      </div>
    );
  }

  render() {
//    var thead = this.createHeader(this.state.columns);
//    var tbody = this.createBody(this.state.data);
    
    var thead = this.createHeader(this.props.columns);
    var tbody = this.createBody(this.props.data);

    return (
      <div className="table-container">
        <div className="table">
          {thead}
          {tbody}
        </div>
      </div>
      
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    activeURI : state.appReducer.activeURI,
    activeData: state.appReducer.activeData,
    menuList: state.apiReducer.menuList,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveMenu: (uri) => dispatch(repositoryActions.updateActiveMenu(uri)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(AVATable);
